module.exports = __webpack_public_path__ + "static/order_of_scribes-de425ee98f08020389270fccc28b89dd.png";